// https://internal.msmaster.qa.paypal.com/elmo/experiment/137882

import * as pxp from '../lib/pxp'

export function isFeeTransparencyTrmt() {
  return pxp.isTreatment('Trmt_p2p_fee_transparency')
}

export function isFeeTransparencyUpliftTrmt() {
  return pxp.isTreatment('Trmt_p2p_fee_transparency_uplift')
}
